import type { Staff } from "@/lib/authv2/store";
import { ACTION } from "@/lib/auth/actions";
import { hasPermission } from "@/lib/authv2/permissions";

/** Màn "Kho Ý Tưởng" (QĐ 0445, CEO chốt 3a): chỉ CEO + giám đốc. */
export function canReadIdeaBank(staff: Staff | null): boolean {
  if (!staff) return false;
  return hasPermission(ACTION.IdeaBankRead);
}

export function canGradeIdeaBank(staff: Staff | null): boolean {
  if (!staff) return false;
  return hasPermission(ACTION.IdeaBankGrade);
}
